import { render, staticRenderFns } from "./TabUser.vue?vue&type=template&id=dfc07056&scoped=true"
import script from "./TabUser.vue?vue&type=script&lang=js"
export * from "./TabUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc07056",
  null
  
)

export default component.exports